<script>
import {gmapApi} from 'vue2-google-maps';

export default {
    name: "FieldDrawMapComponent",

    props: ['acreageInputId', 'field', 'company', 'region', 'currentFieldId'],

    data: function () {
        return {
            drawingManager: {},
            map: {},
            polygon: null,

            center: {lat: 50.4501, lng: 30.5234},
            geo: {},
            acreage: 0,

            fields: [],

            fieldLocal: this.field,
            companyLocal: this.company,
            regionLocal : this.region,
            subRegionLocal: null,
            prevAcreage: null

        };
    },

    computed: {
        google: gmapApi
    },

    mounted () {
        Livewire.on('updateSubRegionId', this.updateSubRegion)
        Livewire.on('updateRegionId', this.updateRegion);
        Livewire.on('select-field-company', this.updateCompany);
        Livewire.on('new-select-field-company', this.updateCompany);

        this.$refs.mapEl.$mapPromise.then((map) => {
            this.initMap(map);

            this.getOtherFields();
        });

        // if(this.region) {
        //     this.updateRegion(this.region);
        // }
    },

    methods: {
        updateAcreage() {
            // if(
            //     (this.prevAcreage && this.prevAcreage === document.getElementById(this.acreageInputId).value) ||
            //     (!this.prevAcreage && document.getElementById(this.acreageInputId).value === '')
            // ) {
            if (!document.getElementById(this.acreageInputId).value || document.getElementById(this.acreageInputId).value === '' || document.getElementById(this.acreageInputId).value === '0') {
                document.getElementById(this.acreageInputId).setAttribute('value', this.acreage);
                this.prevAcreage = this.acreage;
            }
            // }
        },

        initMap(map) {

            this.map = map;

            let google = this.google;

            let center = { x: 50.4501, y: 30.5234 }

            if (this.fieldLocal && this.fieldLocal.length > 0) {
                center = this.polygonCenter(this.fieldLocal);
            }

            const mapOptions = {
                zoom: 6,
                center: new google.maps.LatLng(center.x, center.y),
                mapTypeId: 'hybrid',
                mapTypeControl: false,
                scaleControl: true,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
            }

            const polyOptions = {strokeWeight: 0, fillOpacity: 0.45, editable: true, fillColor: '#b0b616'}

            let drawingManager = new google.maps.drawing.DrawingManager({
                drawingMode: google.maps.drawing.OverlayType.POLYGON,
                drawingControl: true,
                drawingControlOptions: {
                    position: google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: ['polygon'],
                },
                polygonOptions: polyOptions,
            })

            this.drawingManager = drawingManager;

            drawingManager.setMap(map)

            google.maps.event.addDomListener(drawingManager, 'polygoncomplete', polygon => {
                this.polygon = polygon;

                const path = polygon.getPath();

                let coords = []

                for (let i = 0; i < path.length; i++) {
                    coords.push({
                        lat: path.getAt(i).lat(),
                        lng: path.getAt(i).lng(),
                    })
                }

                const ac_co = 0.00024710538146717
                const area = google.maps.geometry.spherical.computeArea(path)
                const acreage = ((area * ac_co) / 2.4711).toFixed(1)

                this.geo = coords;
                this.acreage = acreage;

                this.updateAcreage();

                drawingManager.setOptions({drawingMode: null, drawingControl: false});
                drawingManager.setMap(map);

                google.maps.event.addListener(path, 'set_at', () => {
                    let area = google.maps.geometry.spherical.computeArea(path)
                    let acreage = ((area * ac_co) / 2.4711).toFixed(1)

                    this.geo = coords;
                    this.acreage = acreage;

                    this.updateAcreage();

                    drawingManager.setOptions({drawingMode: null, drawingControl: false});
                    drawingManager.setMap(map);
                });
            })

            if(this.fieldLocal) {
                this.drawPolygon();
            }
        },

        polygonCenter(vertices) {
            let lowx,
                highx,
                lowy,
                highy,
                lats = [],
                lngs = []

            for (let i = 0; i < vertices.length; i++) {
                lngs.push(vertices[i].lng)
                lats.push(vertices[i].lat)
            }

            lats.sort()
            lngs.sort()
            lowx = lats[0]
            highx = lats[vertices.length - 1]
            lowy = lngs[0]
            highy = lngs[vertices.length - 1]

            let center_x = lowx + (highx - lowx) / 2
            let center_y = lowy + (highy - lowy) / 2

            return {x: center_x, y: center_y};
        },

        drawPolygon() {
            let geo = this.fieldLocal;
            let google = this.google;

            if (geo) {
                if (geo.length === 0) {
                    this.drawingManager.setOptions({
                        drawingMode: google.maps.drawing.OverlayType.POLYGON,
                        drawingControl: true,
                    })
                    this.polygon = new google.maps.Polygon()
                    this.polygon.setMap(null)
                    this.polygon = null
                    this.drawingManager.setMap(this.map)
                } else {
                    const center = this.polygonCenter(geo)
                    const coords = geo.map(p => new google.maps.LatLng(parseFloat(p.lat), parseFloat(p.lng)))

                    this.polygon = new google.maps.Polygon({
                        paths: coords,
                        strokeWeight: 0,
                        fillOpacity: 0.45,
                        editable: false,
                        fillColor: '#b0b616',
                    })

                    this.map.setZoom(12);
                    this.map.setCenter(new google.maps.LatLng(center.x, center.y));

                    const path = this.polygon.getPath()
                    const ac_co = 0.00024710538146717
                    const area = google.maps.geometry.spherical.computeArea(path)

                    this.acreage = ((area * ac_co) / 2.4711).toFixed(1);
                    this.updateAcreage();

                    this.geo = this.fieldLocal;
                    this.drawingManager.setOptions({ drawingMode: null, drawingControl: false })
                    this.drawingManager.setMap(this.map)
                    this.polygon.setMap(this.map)
                }
            }
        },

        clear() {
            let google = this.google;

            if(!google) {
                return;
            }

            this.geo = {};

            this.acreage = 0;
            this.updateAcreage();

            if(google.maps) {
                this.drawingManager.setOptions({ drawingMode: google.maps.drawing.OverlayType.POLYGON, drawingControl: true })
            }

            if(this.polygon) {
                this.polygon.setMap(null)
                this.polygon = null
            }

            this.drawingManager.setMap(this.map)
        },

        renderFields() {
            if (! this.fields || this.fields.length <= 0) {
                return null;
            }

            let polygons = [];

            for (let i = 0; i < this.fields.length; i++) {

                if(this.currentFieldId == this.fields[i].id) {
                    continue;
                }

                let geo = this.fields[i].geo;

                if(geo === null) {
                    geo = [];
                }

                geo = geo.map(c => {
                    return {
                        lng: parseFloat(c.lng), lat: parseFloat(c.lat)
                    };
                });

                let polygon = new this.google.maps.Polygon({
                    paths: geo,
                    strokeWeight: 1,
                    fillOpacity: 0.45,
                    editable: false,
                    fillColor: '#c4c9cd',
                });

                polygon.setMap(this.map);
                polygons.push(polygon);
            }

            this.fields = polygons;
        },

        getOtherFields() {
            if(! this.companyLocal || ! this.regionLocal) {
                return;
            }

            axios.get(`/fields/${this.companyLocal}/${this.regionLocal}`)
                .then((response) => {
                    if(response.data.status !== 'success') {
                        console.error(response);

                        this.$eventBus.$emit('alert', 'error', 'Під час завантаження полів виникла невідома помилка.');
                    } else {
                        this.fields = response.data.data;

                        this.renderFields();
                    }
                }).catch((error) => {
                    console.error(error);

                    this.$eventBus.$emit('alert', 'error', 'Під час завантаження полів виникла невідома помилка.');
                });
        },

        updateCompany(name, id) {

            this.companyLocal = id;

            this.getOtherFields();
        },

        updateRegion(regionId) {
            this.clear();

            this.regionLocal = regionId;

            this.getOtherFields();

            if(! this.regionLocal) {
                return;
            }

            axios.get(`/regions/${this.regionLocal}`)
                .then((response) => {
                    //console.log(response);

                    if(response.data.status !== 'success') {
                        console.error(response);

                        this.$eventBus.$emit('alert', 'error', 'Під час завантаження регіону виникла невідома помилка.');
                    } else {
                        let center = response.data.data.center;

                        this.map.setZoom(12);
                        this.map.setCenter(new google.maps.LatLng(center[0], center[1]));
                    }
                }).catch((error) => {
                    console.error(error);

                    this.$eventBus.$emit('alert', 'error', 'Під час завантаження регіону виникла невідома помилка.');
                });
        },

        updateSubRegion(subRegionId) {
            //console.log('update sub region: ' + subRegionId);
        }
    }
}
</script>

<style scoped>

</style>
